module.exports = __webpack_public_path__ + "564dcf3a01456f292e238987fc77c7f9.png";